import { HoverAction } from '~/modules/page-builder/component/common/hover-action/HoverAction';
import {
    Button,
    pxToRem,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import type { ButtonProps } from '@archipro-design/aria';
import { Download2Line } from '@archipro-design/icons';
import { useTracker } from '@archipro-website/tracker';
import { encodeDownloadLink } from '../../detail-single-image-shell/HoverButtonsImage';

const HOVER_BUTTON_PADDING = 12;
const HOVER_BUTTON_PADDING_MOBILE = 8;
const HOVER_BUTTON_BORDER_RADIUS = '50%';

interface DownloadActionProps {
    canDownload: boolean;
    downloadLink: string;
    libraryImageID?: number;
}

const DownloadAction = ({
    canDownload,
    downloadLink,
    libraryImageID,
}: DownloadActionProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const tracker = useTracker();

    const buttonParams: Pick<ButtonProps, 'size' | 'color' | 'variables'> = {
        size: isMobile ? 16 : 24,
        color: 'grey',
        variables: {
            buttonRadius: HOVER_BUTTON_BORDER_RADIUS,
            buttonPadding: pxToRem(
                isMobile ? HOVER_BUTTON_PADDING_MOBILE : HOVER_BUTTON_PADDING,
            ),
            iconPadding: 0,
        },
    };

    if (!canDownload || !libraryImageID || !downloadLink) {
        return null;
    }

    return (
        <HoverAction
            label={'Download'}
            action={
                <Button
                    as="a"
                    icon={<Download2Line />}
                    href={encodeDownloadLink(downloadLink)}
                    download
                    {...buttonParams}
                    onClick={() => {
                        tracker.log('StaffDownloadImage', {
                            url: new URL(window.location.href),
                            targetTracker: 'archiproTracker',
                            data: {
                                // ImageID
                                ExtraData: libraryImageID,
                            },
                        });
                    }}
                    className="bg-gray-100/50 backdrop-blur-xl hover:bg-gray-100"
                />
            }
        />
    );
};

export default DownloadAction;
